export default __webpack_public_path__ + "static/media/login.3c8f65df.jpg";